<template>
  <div>
    <div>
      <el-button
        v-if="Permit.canActions('scheduleManage')"
        type="success"
        style="width: 100%"
        class="mgb10"
        @click="
          Permit.isFreeEdition()
            ? checkTenantValid('createSchedule')
            : createSchedule()
        "
      >
        {{ $t("action.createSchedule") }}
      </el-button>
    </div>
    <panel title="今天预约">
      <template v-slot:right v-if="schedule != null">
        值班：<span v-if="schedule.duty">
          {{ schedule.duty.dutyName || "暂无" }}
        </span>
        <span v-else>暂无</span>
      </template>
      <div class="content" v-if="schedule != null">
        <div
          v-for="(slot, slotsIndex) of schedule.slots"
          :key="slotsIndex"
          class="flex flex-between mgb20"
        >
          <div style="width: 100px">
            {{ slot.startTime.slice(0, 5) }}-{{ slot.endTime.slice(0, 5) }}
          </div>
          <div style="width: 260px">
            <div
              class="flex"
              style="flex-wrap: wrap"
              :class="
                slot.fittingRooms.length !== 0 &&
                slot.otherSchedules.length != 0
                  ? 'mgb10'
                  : ''
              "
            >
              <div
                v-for="(fittingRoom, fittingRoomIndex) of slot.fittingRooms"
                :key="fittingRoomIndex"
                style="width: 100px; height: 100px; position: relative"
                class="border pd5 mgr5 mgb5"
              >
                <!-- <div
                  class="font10 center"
                  @click="
                    fittingRoom.lock ? showRecord(fittingRoom.lockSchedule) : ''
                  "
                  :class="
                    fittingRoom.lock
                      ? 'color-' + fittingRoom.lockSchedule.workflowState
                      : ''
                  "
                  style="line-height: 100px"
                >
                  {{ fittingRoom.name }}
                </div> -->

                <div
                  v-if="fittingRoom.lock"
                  class="font10 center"
                  @click="showRecord(fittingRoom.lockSchedule)"
                  :class="'color-' + fittingRoom.lockSchedule.workflowState"
                >
                  {{ fittingRoom.name }}
                  <div v-if="fittingRoom.lockSchedule != null" class="mgt10">
                    <div
                      :class="'color-' + fittingRoom.lockSchedule.workflowState"
                      class="font8"
                    >
                      {{ fittingRoom.lockSchedule.title }}
                    </div>
                    <div
                      :class="'color-' + fittingRoom.lockSchedule.workflowState"
                      class="font8"
                    >
                      {{ fittingRoom.lockSchedule.customerName }}
                    </div>
                  </div>
                </div>
                <div v-else class="font10 center" style="line-height: 100px">
                  {{ fittingRoom.name }}
                </div>

                <div style="position: absolute; bottom: 0; right: 0">
                  <template v-if="fittingRoom.lock">
                    <i class="el-icon-lock"></i>
                    <el-dropdown
                      v-if="
                        Permit.canActions('scheduleManage') ||
                        Permit.canActions('scheduleDeal')
                      "
                    >
                      <a class="el-dropdown-link small-link">
                        <i class="el-icon-arrow-down"></i>
                      </a>
                      <el-dropdown-menu slot="dropdown">
                        <template v-if="Permit.canActions('scheduleDeal')">
                          <el-dropdown-item>
                            <div
                              class="font10"
                              @click="
                                Permit.isFreeEdition()
                                  ? checkTenantValid(
                                      'tranPlace',
                                      fittingRoom.lockSchedule
                                    )
                                  : tranPlace(fittingRoom.lockSchedule)
                              "
                            >
                              {{ $t("action.tranPlace") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="fittingRoom.lockSchedule.customerId == null"
                          >
                            <div
                              class="font10"
                              @click="tranCustomer(fittingRoom.lockSchedule)"
                            >
                              {{ $t("action.tranCustomer") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'canceled'].includes(
                                fittingRoom.lockSchedule.workflowState
                              )
                            "
                            :loading="transDoing"
                          >
                            <div
                              class="font10"
                              @click="finish(fittingRoom.lockSchedule)"
                            >
                              {{ $t("action.yuyue")
                              }}{{ $t("action.finishDone") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'giveUp', 'canceled'].includes(
                                fittingRoom.lockSchedule.workflowState
                              )
                            "
                            :loading="giveUpDoing"
                          >
                            <div
                              class="font10"
                              @click="giveUp(fittingRoom.lockSchedule)"
                            >
                              {{ $t("action.yuyue")
                              }}{{ $t("action.finishGiveUp") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'giveUp', 'canceled'].includes(
                                fittingRoom.lockSchedule.workflowState
                              )
                            "
                            :loading="cancelDoing"
                          >
                            <div
                              class="font10"
                              @click="cancel(fittingRoom.lockSchedule)"
                            >
                              {{ $t("action.yuyue") }}{{ $t("action.cancel") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <div
                              class="font10"
                              @click="addFollow(fittingRoom.lockSchedule)"
                            >
                              {{ $t("action.addFollow") }}
                            </div>
                          </el-dropdown-item>
                        </template>
                        <el-dropdown-item
                          v-if="
                            fittingRoom.lockSchedule.workflowState != 'done' &&
                            Permit.canActions('scheduleManage')
                          "
                        >
                          <div
                            class="font10"
                            @click="edit(fittingRoom.lockSchedule, 'quickEdit')"
                          >
                            {{ $t("action.yuyue") }}{{ $t("text.edit") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="Permit.canActions('scheduleDelete')"
                        >
                          <el-popconfirm
                            :title="$t('prompt.confirmDelete')"
                            @confirm="deleteRow(fittingRoom.lockSchedule)"
                          >
                            <div slot="reference" type="text" class="font10">
                              {{ $t("action.yuyue") }}{{ $t("text.delete") }}
                            </div>
                          </el-popconfirm>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </div>
              </div>
            </div>
            <div
              v-for="(otherSchedule, otherScheduleIndex) of slot.otherSchedules"
              :key="otherScheduleIndex"
              class="mgb10"
            >
              <div class="flex">
                <div
                  class="mgr5 font10"
                  @click="showRecord(otherSchedule)"
                  :class="'color-' + otherSchedule.workflowState"
                >
                  {{ otherSchedule.planAt.slice(11, 16) }}
                </div>
                <div>
                  <div
                    class="font10"
                    @click="showRecord(otherSchedule)"
                    :class="'color-' + otherSchedule.workflowState"
                  >
                    {{ $t("schedule.title") }}：{{ otherSchedule.title }}
                  </div>
                  <div
                    class="font10"
                    :class="'color-' + otherSchedule.workflowState"
                  >
                    {{ $t("menu.customers") }}：{{ otherSchedule.customerName }}
                    <el-dropdown
                      v-if="
                        Permit.canActions('scheduleManage') ||
                        Permit.canActions('scheduleDeal')
                      "
                    >
                      <a class="el-dropdown-link small-link">
                        <i class="el-icon-arrow-down"></i>
                      </a>
                      <el-dropdown-menu slot="dropdown">
                        <template v-if="Permit.canActions('scheduleDeal')">
                          <el-dropdown-item>
                            <div
                              class="font10"
                              @click="
                                Permit.isFreeEdition()
                                  ? checkTenantValid('tranPlace', otherSchedule)
                                  : tranPlace(otherSchedule)
                              "
                            >
                              {{ $t("action.tranPlace") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="otherSchedule.customerId == null"
                          >
                            <div
                              class="font10"
                              @click="tranCustomer(otherSchedule)"
                            >
                              {{ $t("action.tranCustomer") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'canceled'].includes(
                                otherSchedule.workflowState
                              )
                            "
                            :loading="transDoing"
                          >
                            <div class="font10" @click="finish(otherSchedule)">
                              {{ $t("action.yuyue")
                              }}{{ $t("action.finishDone") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'giveUp', 'canceled'].includes(
                                otherSchedule.workflowState
                              )
                            "
                            :loading="giveUpDoing"
                          >
                            <div class="font10" @click="giveUp(otherSchedule)">
                              {{ $t("action.yuyue")
                              }}{{ $t("action.finishGiveUp") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="
                              !['done', 'giveUp', 'canceled'].includes(
                                otherSchedule.workflowState
                              )
                            "
                            :loading="cancelDoing"
                          >
                            <div class="font10" @click="cancel(otherSchedule)">
                              {{ $t("action.yuyue") }}{{ $t("action.cancel") }}
                            </div>
                          </el-dropdown-item>
                          <el-dropdown-item>
                            <div
                              class="font10"
                              @click="addFollow(otherSchedule)"
                            >
                              {{ $t("action.addFollow") }}
                            </div>
                          </el-dropdown-item>
                        </template>
                        <el-dropdown-item
                          v-if="
                            otherSchedule.workflowState != 'done' &&
                            Permit.canActions('scheduleManage')
                          "
                        >
                          <div
                            class="font10"
                            @click="edit(otherSchedule, 'edit')"
                          >
                            {{ $t("action.yuyue") }}{{ $t("text.edit") }}
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item
                          v-if="Permit.canActions('scheduleDelete')"
                        >
                          <el-popconfirm
                            :title="$t('prompt.confirmDelete')"
                            @confirm="deleteRow(otherSchedule)"
                          >
                            <div slot="reference" type="text" class="font10">
                              {{ $t("action.yuyue") }}{{ $t("text.delete") }}
                            </div>
                          </el-popconfirm>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
              </div>
              <!-- <span
               
              >
                {{ otherSchedule.planAt.slice(11, 16) }}&nbsp;&nbsp;&nbsp;
                {{ $t("schedule.title") }}：{{ otherSchedule.title }}
                <div>
                  {{ $t("menu.customers") }}：{{ otherSchedule.customerName }}
                </div>
              </span> -->
            </div>
          </div>
        </div>
      </div>
      <div v-else class="content noData">
        {{ $t("text.noData") }}
      </div>

      <!-- ============ -->
      <drawer
        :title="$t('text.view')"
        :visible.sync="showDF"
        size="900px"
        direction="rtl"
        :wrapper-closable="false"
        :destroy-on-close="true"
      >
        <show :id="currentRowId" />
      </drawer>
      <!-- 预约 -->
      <el-dialog
        :title="$t('text.create')"
        :close-on-click-modal="false"
        :visible.sync="addDF"
        width="50%"
      >
        <el-form ref="addObjForm" :model="addObj" label-width="70px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('schedule.title')"
                :prop="'title'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('schedule.title')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-autocomplete
                  size="small"
                  v-model.trim="addObj.title"
                  :fetch-suggestions="querySearchTitle"
                  style="width: 100%"
                  @select="handleSelectTitle"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('schedule.type')"
                :prop="'type'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('schedule.type')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model.trim="addObj.type"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="scheduleType in scheduleTypes"
                    :key="scheduleType.id"
                    :label="scheduleType.name"
                    :value="scheduleType.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col :span="16">
                  <el-form-item
                    :label="$t('text.date')"
                    :prop="'_planAt1'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.date')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      id="right-radius"
                      size="small"
                      v-model.trim="addObj._planAt1"
                      type="date"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="0px"
                    :prop="'_planAt2'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.time')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-time-select
                      size="small"
                      id="left-radius"
                      style="width: 100%"
                      v-model="addObj._planAt2"
                      :picker-options="{
                        start: '08:30',
                        step: '00:30',
                        end: '20:30',
                      }"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.customers')"
                :prop="'customerName'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.customers')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-autocomplete
                  size="small"
                  v-model="addObj.customerName"
                  :fetch-suggestions="querySearchCustomer"
                  style="width: 100%"
                  :trigger-on-focus="false"
                  @select="handleSelectCustomer"
                >
                  <template slot-scope="{ item }">
                    <div class="name">{{ item.name }}</div>
                    <span class="addr">{{ item.phone }}</span>
                  </template>
                </el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.shops')"
                :prop="'type'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.shops')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="addObj.shopId"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="shop in shops"
                    :key="shop.id"
                    :label="shop.name"
                    :value="shop.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('customer.source')">
                <el-select
                  size="small"
                  v-model="addObj.source"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="source in sources"
                    :key="source.id"
                    :label="source.name"
                    :value="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('customer.sourceRemark')">
                <el-autocomplete
                  size="small"
                  v-model="addObj.sourceRemark"
                  :fetch-suggestions="querySearchSourceRemarks"
                  style="width: 100%"
                  @select="handleSelectSourceRemarks"
                >
                </el-autocomplete>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('customer.suggestName')"
                :prop="'suggestName'"
              >
                <el-select
                  size="small"
                  v-model.trim="addObj.suggestId"
                  filterable
                  remote
                  clearable
                  :loading="customersLoading"
                  :placeholder="$t('customer.phoneName')"
                  :remote-method="querySearchCustomerSuggest"
                  @change="handleSelectCustomerSuggest"
                >
                  <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :label="customer.name + '(' + customer.phone + ')'"
                    :value="customer.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item :label="$t('text.remark')" :prop="'content'">
                <el-input size="small" v-model.trim="addObj.content" />
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="addDoing"
            size="small"
            @click="addSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="addDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- ============ -->

      <el-dialog
        :title="$t('text.edit')"
        :close-on-click-modal="false"
        :visible.sync="editDF"
        width="50%"
      >
        <el-form ref="editObjForm" :model="editObj" label-width="60px">
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('schedule.title')"
                :prop="'title'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('schedule.title')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-input size="small" v-model.trim="editObj.title" />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('schedule.type')"
                :prop="'type'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('schedule.type')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-select
                  size="small"
                  v-model="editObj.type"
                  filterable
                  clearable
                >
                  <el-option
                    v-for="scheduleType in scheduleTypes"
                    :key="scheduleType.id"
                    :label="scheduleType.name"
                    :value="scheduleType.name"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-row>
                <el-col :span="16">
                  <el-form-item
                    :label="$t('text.date')"
                    :prop="'_planAt1'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.date')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      id="right-radius"
                      size="small"
                      v-model.trim="editObj._planAt1"
                      type="date"
                      style="width: 100%"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    label-width="0px"
                    :prop="'_planAt2'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.time')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-time-select
                      id="left-radius"
                      size="small"
                      style="width: 100%"
                      v-model="editObj._planAt2"
                      :picker-options="{
                        start: '08:30',
                        step: '00:30',
                        end: '20:30',
                      }"
                    >
                    </el-time-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-col :span="12">
              <el-form-item
                :label="$t('menu.customers')"
                :prop="'customerName'"
                :rules="[
                  {
                    required: true,
                    message: $t('rules.required', [$t('menu.customers')]),
                    trigger: 'blur',
                  },
                ]"
              >
                <el-autocomplete
                  size="small"
                  v-model.trim="editObj.customerName"
                  :fetch-suggestions="querySearchCustomer"
                  style="width: 100%"
                  :trigger-on-focus="false"
                  @select="handleSelectCustomerEdit"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('customer.source')">
                <el-select
                  size="small"
                  v-model="editObj.source"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="source in sources"
                    :key="source.id"
                    :label="source.name"
                    :value="source.name"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('customer.sourceRemark')">
                <el-autocomplete
                  size="small"
                  v-model="editObj.sourceRemark"
                  :fetch-suggestions="querySearchSourceRemarks"
                  style="width: 100%"
                  @select="handleSelectSourceRemarks"
                ></el-autocomplete>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item
                :label="$t('customer.suggestName')"
                :prop="'suggestName'"
              >
                <el-select
                  size="small"
                  v-model.trim="editObj.suggestId"
                  filterable
                  remote
                  clearable
                  :loading="customersLoading"
                  :placeholder="$t('customer.phoneName')"
                  :remote-method="querySearchCustomerSuggest"
                  @change="handleSelectCustomerSuggest"
                >
                  <el-option
                    v-for="customer in customers"
                    :key="customer.id"
                    :label="customer.name + '(' + customer.phone + ')'"
                    :value="customer.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('text.remark')" :prop="'content'">
                <el-input
                  size="small"
                  v-model.trim="editObj.content"
                  type="textarea"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="actionName == 'quickEdit'">
            <el-col :span="4">
              <el-form-item :label="$t('schedule.makeup')" :prop="'makeup'">
                <el-checkbox v-model="editObj.makeup"></el-checkbox>
              </el-form-item>
            </el-col>
            <el-col :span="8" v-if="editObj.makeup == true">
              <el-form-item :label="$t('schedule.makeupName')" :prop="'makeup'">
                <el-select
                  size="small"
                  v-model="editObj.makeupId"
                  filterable
                  remote
                  :remote-method="querySearchProductNo"
                  :loading="productsLoading"
                  :clearable="true"
                  @change="handleSelectProductNo"
                >
                  <el-option
                    v-for="product in serviceProducts"
                    :key="product.id"
                    :label="product.productNo"
                    :value="product.id"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="editDoing"
            size="small"
            @click="editSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="editDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- 添加跟踪 -->
      <el-dialog
        :title="$t('customer.follow')"
        :close-on-click-modal="false"
        :visible.sync="addFollowDF"
        width="30%"
      >
        <el-form ref="addFollowForm" :model="addFollowObj">
          <el-form-item
            :prop="'content'"
            :rules="[
              {
                required: true,
                message: $t('rules.required', [$t('text.content')]),
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              size="small"
              v-model.trim="addFollowObj.content"
              :placeholder="$t('text.content')"
              type="textarea"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="addFollowSubmitDoing"
            size="small"
            @click="addFollowSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="addFollowDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- 转化客户 -->
      <el-dialog
        :title="$t('action.tranCustomer')"
        :close-on-click-modal="false"
        :visible.sync="tranCustomerDF"
        width="60%"
      >
        <el-form
          ref="tranCustomerObjForm"
          :model="tranCustomerObj"
          label-width="80px"
        >
          <fieldset class="mgb15">
            <legend>{{ $t("text.baseInfo") }}</legend>
            <el-row>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.phone')"
                  :prop="'phone'"
                  :rules="[
                    {
                      required: true,
                      validator: validatePhone,
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="tranCustomerObj.phone"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('user.name')"
                  :prop="'name'"
                  :rules="[
                    {
                      required: true,
                      message: $t('rules.required', [$t('user.name')]),
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input
                    size="small"
                    v-model.trim="tranCustomerObj.name"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('customer.email')" :prop="'email'">
                  <el-input
                    size="small"
                    v-model.trim="tranCustomerObj.email"
                    :placeholder="$t('customer.email')"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.province')" :prop="'province'">
                  <el-input
                    size="small"
                    v-model.trim="tranCustomerObj.province"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.city')" :prop="'city'">
                  <el-input size="small" v-model.trim="tranCustomerObj.city" />
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item :label="$t('tenant.address')" :prop="'address'">
                  <el-input
                    size="small"
                    v-model.trim="tranCustomerObj.address"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item :label="$t('customer.source')">
                  <el-select
                    size="small"
                    v-model="tranCustomerObj.source"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="source in sources"
                      :key="source.id"
                      :label="source.name"
                      :value="source.name"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.sourceRemark')"
                  :prop="'sourceRemark'"
                >
                  <el-autocomplete
                    size="small"
                    v-model="tranCustomerObj.sourceRemark"
                    :fetch-suggestions="querySearchSourceRemarks"
                    style="width: 100%"
                    @select="handleSelectSourceRemarks"
                  ></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="$t('customer.suggestName')"
                  :prop="'suggestName'"
                >
                  <el-select
                    size="small"
                    v-model.trim="tranCustomerObj.suggestId"
                    filterable
                    remote
                    clearable
                    :loading="customersLoading"
                    :placeholder="$t('customer.phoneName')"
                    :remote-method="querySearchCustomerSuggest"
                    @change="handleSelectCustomerSuggest"
                  >
                    <el-option
                      v-for="customer in customers"
                      :key="customer.id"
                      :label="customer.name + '(' + customer.phone + ')'"
                      :value="customer.id"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
          <fieldset class="mgb15">
            <legend>{{ $t("text.remark") }}</legend>
            <el-input
              size="small"
              v-model.trim="tranCustomerObj.remark"
              type="textarea"
              :rows="3"
            />
          </fieldset>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button
            type="primary"
            plain
            :loading="tranCustomerSubmitDoing"
            size="small"
            @click="tranCustomerSubmit"
            >{{ $t("text.submit") }}</el-button
          >
          <el-button size="small" @click="tranCustomerDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
      <!-- 转化下单 -->
      <el-dialog
        :title="$t('action.tranPlace')"
        :close-on-click-modal="false"
        :visible.sync="tranPlaceDF"
        width="60%"
      >
        <rent-package
          source="schedule"
          :customerId="customerId"
          :customerName="customerName"
        ></rent-package>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="tranPlaceDF = false">{{
            $t("text.close")
          }}</el-button>
        </div>
      </el-dialog>
    </panel>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import { page } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import RentPackage from "@/views/portals/RentPackage";
import Schedule from "@/api/schedule.js";
import Customer from "@/api/customer.js";
import User from "@/api/user.js";
import ScheduleFollow from "@/api/scheduleFollow.js";
import Shop from "@/api/shop.js";
import Source from "@/api/source.js";
import ScheduleType from "@/api/scheduleType";
import UserAuth from "@/api/userAuth";
import Product from "@/api/product";
import Show from "@/views/schedules/show";

export default {
  mixins: [page],
  components: {
    RentPackage,
    Show,
  },
  data() {
    var validatePhone = (rule, value, callback) => {
      const self = this;
      if (value == null || value.trim() === "") {
        callback(new Error(self.$t("rules.required", [self.$t("user.phone")])));
        return;
      }
      Customer.findByPhone({ keyword: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(new Error(self.$t("prompt.hasBeenAdded")));
          return;
        } else {
          User.findByPhone({ phone: value }).then(function (res) {
            if (res.data.code === 200) {
              const user = res.data.entity;
              if (user.tenantId === self.Permit.currentTenant().id) {
                callback(new Error(self.$t("prompt.notAddOneself")));
                return;
              }
              if (user.admin === false) {
                callback(new Error(self.$t("prompt.notAddSubaccounts")));
                return;
              }
              self.tranCustomerObj.name = user.tenant.placeName;
              self.tranCustomerObj.province = user.tenant.province;
              self.tranCustomerObj.city = user.tenant.city;
              self.tranCustomerObj.address = user.tenant.address;
              self.tranCustomerObj.sourceTenantId = user.tenant.id;
              callback();
            } else {
              self.tranCustomerObj.sourceTenantId = null;
              callback();
              return;
            }
          });
        }
      });
    };
    return {
      loading: false,
      schedule: null,
      //
      currentRowId: null,
      showDF: false,
      dayIndex: null,
      daySchedule: null,

      // 新增预约
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "明天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周后",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      shops: [],
      scheduleTypes: [],
      sources: [],
      titles: [],
      selectDay: null,
      addDF: false,
      addObj: {
        title: null,
        type: null,
        planAt: null,
        _planAt1: null,
        _planAt2: null,
        customerId: null,
        customerName: null,
        content: null,
        shopId: null,
        source: null,
        sourceRemark: null,
        suggestId: null,
        //
        fit: false,
        fitName: null,
        fitStartTime: null,
        fitEndTime: null,
        makeup: null,
        makeupStartTime: null,
        makeupEndTime: null,
        product: null,
      },
      currentShopTimeSlots: [],
      currentShopTimeSlotsMakeup: [],
      currentShopFittingRooms: [],
      customers: [],
      customersLoading: false,
      addDoing: false,

      //
      transDoing: false,
      giveUpDoing: false,
      cancelDoing: false,
      // 编辑
      scheduleTypes: [],
      row: null,
      selectDay: null,
      editDF: false,
      editObj: {
        title: null,
        type: null,
        planAt: null,
        _planAt1: null,
        _planAt2: null,
        customerId: null,
        customerName: null,
        content: null,
        source: null,
        sourceRemark: null,
        suggestId: null,

        fit: false,
        fitId: null,
        fitName: null,
        fitStartTime: null,
        fitEndTime: null,
        makeup: null,
        makeupStartTime: null,
        makeupEndTime: null,
        makeupId: null,
        makeupName: null,
      },
      editDoing: false,
      // 新增跟踪
      addFollowDF: false,
      addFollowObj: { content: null, scheduleId: null },
      addFollowSubmitDoing: false,
      // 新增跟踪
      addFollowDF: false,
      addFollowObj: { content: null, scheduleId: null },
      addFollowSubmitDoing: false,
      // 转化客户

      validatePhone: validatePhone,
      shops: [],
      customers: [],
      sources: [],
      customersLoading: false,
      tranCustomerDF: false,
      tranCustomerObj: {
        name: null,
        phone: null,
        province: null,
        city: null,
        address: null,
        remark: null,
        email: null,
        source: null,
        sourceRemark: null,
        suggestId: null,
      },
      tranCustomerSubmitDoing: false,
      // 转化下单
      tranPlaceDF: false,
      customerId: null,
      customerName: null,
      //
      actionName: null,
      serviceProductsAll: [],
      serviceProducts: [],
      productsLoading: false,
    };
  },
  created() {
    const self = this;
    self.getTodaySchedule();
  },
  methods: {
    checkTenantValid(action, row) {
      const self = this;
      UserAuth.checkTenantValid().then(function (res) {
        if (res.status == 200) {
          if (res.data.type == "fail") {
            self.sysResultCheckTenantValid(res.data);
            return;
          }
          if (action == "createSchedule") {
            self.createSchedule();
          }
          if (action == "tranPlace") {
            self.tranPlace(row);
          }
        } else {
          self.sysError();
        }
      });
    },
    getServiceProducts() {
      const self = this;
      Product.findAllService().then(function (res) {
        if (res.status == 200) {
          self.serviceProductsAll = res.data;
          self.serviceProducts = res.data;
        } else {
          self.sysError();
        }
      });
    },
    // 新增
    createSchedule() {
      const self = this;
      self.getSources();
      self.getScheduleTypes();
      self.getServiceProducts();
      self.addObj.title = null;
      self.addObj.type = null;
      self.addObj.planAt = null;
      self.addObj._planAt1 = null;
      self.addObj._planAt2 = null;
      self.addObj.customerId = null;
      self.addObj.customerName = null;
      self.addObj.content = null;
      self.addObj.source = null;
      self.addObj.sourceRemark = null;
      self.addObj.fitId = null;
      self.addObj.fitName = null;
      self.addObj.fitStartTime = null;
      self.addObj.fitEndTime = null;
      self.addObj.makeup = null;
      self.addObj.makeupStartTime = null;
      self.addObj.makeupEndTime = null;
      self.addObj.makeupId = null;
      self.addObj.makeupName = null;

      Shop.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.shops = res.data;
          if (
            self.shops.find(
              (s) => s.id === self.Permit.currentUser()._shopId
            ) != null
          ) {
            self.addObj.shopId = self.Permit.currentUser()._shopId;
          } else {
            self.addObj.shopId = null;
          }
        } else {
          self.sysError();
        }
      });
      self.addDF = true;
    },
    querySearchTitle(queryString, cb) {
      const self = this;
      Schedule.vagueFindTitle({ title: queryString }).then(function (res) {
        const ps = [...new Set(res.data)].map((r) => {
          return { value: r };
        });
        self.titles = ps;
        cb(self.titles);
      });
    },
    handleSelectTitle() {},
    querySearchCustomer(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.addObj.customerId = null;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.name));
        self.customers = ps;
        cb(self.customers);
      });
    },
    handleSelectCustomer(item) {
      const self = this;
      self.addObj.customerId = item.id;
      self.addObj.source = item.source;
      self.addObj.sourceRemark = item.sourceRemark;
      self.addObj.suggestId = item.suggestId;
    },
    // 具体来源
    querySearchSourceRemarks(queryString, cb) {
      Customer.sourceRemarks().then(function (res) {
        const sourceRemarks = res.data.map((item) => {
          return { value: item };
        });
        cb(sourceRemarks);
      });
    },
    handleSelectSourceRemarks(item) {},
    querySearchCustomerSuggest(queryString, cb) {
      const self = this;
      self.addObj.suggestId = null;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.customersLoading = true;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        self.customers = res.data;
        self.customersLoading = false;
      });
    },
    handleSelectCustomerSuggest() {
      const self = this;
    },
    addSubmit() {
      const self = this;
      self.$refs.addObjForm.validate((valid) => {
        if (valid) {
          this.addObj.planAt =
            Util.formatDate(this.addObj._planAt1) +
            " " +
            this.addObj._planAt2 +
            ":00";
          self.addDoing = true;
          Schedule.create(self.addObj).then(function (res) {
            self.addDoing = false;
            self.addDF = false;
            if (res.data.code === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
              self.getTodaySchedule();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },

    //============================
    //转化客户
    tranCustomer(row) {
      const self = this;
      self.row = row;
      this.tranCustomerObj.phone = null;
      this.tranCustomerObj.name = row.customerName;
      this.tranCustomerObj.province = null;
      this.tranCustomerObj.city = null;
      this.tranCustomerObj.address = null;
      this.tranCustomerObj.remark = null;
      this.tranCustomerObj.source = row.source;
      this.tranCustomerObj.sourceRemark = row.sourceRemark;
      this.tranCustomerObj.suggestId = row.suggestId;
      this.getSources();
      this.tranCustomerSubmitDoing = false;
      this.tranCustomerDF = true;
      if (self.Permit.currentUser()._shopId != null) {
        Shop.findByTenantId().then(function (res) {
          if (res.status === 200) {
            self.shops = res.data;
            const obj = self.shops.find(
              (s) => s.id == self.Permit.currentUser()._shopId
            );
            if (obj != null) {
              self.tranCustomerObj.province = obj.province;
              self.tranCustomerObj.city = obj.city;
              self.tranCustomerObj.address = obj.address;
            }
          } else {
            self.sysError();
          }
        });
      }
    },

    tranCustomerSubmit() {
      const self = this;
      this.$refs.tranCustomerObjForm.validate((valid) => {
        if (valid) {
          self.tranCustomerSubmitDoing = true;
          Customer.create(self.tranCustomerObj).then(function (res) {
            self.tranCustomerSubmitDoing = false;
            self.tranCustomerDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.tranSuccess"),
                type: "success",
              });
              if (res.data.code == 201) {
                self.updateCustomer(res.data.entity);
              }
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    updateCustomer(customer) {
      const self = this;
      let obj = {
        customerId: customer.id,
        customerName: customer.name,
      };
      Schedule.updateCustomer(self.row.id, obj).then(function (res) {
        if (res.status === 200) {
          self.getTodaySchedule();
        } else {
          self.sysError();
        }
      });
    },
    // 下单
    tranPlace(row) {
      const self = this;
      self.row = row;
      self.customerId = row.customerId;
      self.customerName = row.customerName;
      self.tranPlaceDF = true;
    },
    // 新增跟踪
    addFollow(row) {
      this.addFollowObj.content = null;
      this.addFollowObj.scheduleId = row.id;
      this.addFollowSubmitDoing = false;
      this.addFollowDF = true;
    },
    addFollowSubmit() {
      const self = this;
      this.$refs.addFollowForm.validate((valid) => {
        if (valid) {
          self.addFollowSubmitDoing = true;
          ScheduleFollow.create(this.addFollowObj).then(function (res) {
            self.addFollowSubmitDoing = false;
            self.addFollowDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.addSuccess"),
                type: "success",
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 删除
    deleteRow(row) {
      const self = this;
      Schedule.delete(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.delSuccess"),
            type: "success",
          });
          self.getTodaySchedule();
        } else {
          self.sysError();
        }
      });
    },
    // 编辑
    edit(row, action) {
      const self = this;
      self.row = row;
      self.actionName = action;
      self.getSources();
      self.getServiceProducts();
      self.editObj.title = self.row.title;
      self.editObj.type = self.row.type;
      self.editObj._planAt1 = self.row.planAt.slice(0, 10);
      self.editObj._planAt2 = self.row.planAt.slice(11, 16);
      self.editObj.customerId = self.row.customerId;
      self.editObj.customerName = self.row.customerName;
      self.editObj.content = self.row.content;
      self.editObj.source = self.row.source;
      self.editObj.sourceRemark = self.row.sourceRemark;
      self.editObj.suggestId = self.row.suggestId;
      self.editObj.fit = self.row.fit;
      self.editObj.fitId = self.row.fitId;
      self.editObj.fitName = self.row.fitName;
      self.editObj.fitStartTime = self.row.fitStartTime;
      self.editObj.fitEndTime = self.row.fitEndTime;
      self.editObj.makeup = self.row.makeup;
      self.editObj.makeupStartTime = self.row.makeupStartTime;
      self.editObj.makeupEndTime = self.row.makeupEndTime;
      self.editObj.makeupId = self.row.makeupId;
      self.editObj.makeupName = self.row.makeupName;
      self.editDF = true;
    },
    querySearchCustomer(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      self.addObj.customerId = null;
      Customer.vagueFind({ keyword: queryString }).then(function (res) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.name));
        self.customers = ps;
        cb(self.customers);
      });
    },
    handleSelectCustomerEdit(item) {
      const self = this;
      self.editObj.customerId = item.id;
      self.editObj.source = item.source;
      self.editObj.sourceRemark = item.sourceRemark;
    },
    querySearchProductNo(queryString, cb) {
      const self = this;
      this.productsLoading = true;
      if (queryString != null && queryString != "") {
        self.serviceProducts = self.serviceProductsAll.filter(
          (s) => s.productNo.indexOf(queryString) != -1
        );
        this.productsLoading = false;
      }
    },
    handleSelectProductNo() {
      const self = this;
      if (self.actionName == "quickBuildFit") {
        let item = self.serviceProducts.find(
          (p) => p.id == self.addObj.makeupId
        );
        self.addObj.makeupName = item.productNo;
      } else {
        let item = self.serviceProducts.find(
          (p) => p.id == self.editObj.makeupId
        );
        self.editObj.makeupName = item.productNo;
      }
    },
    editSubmit() {
      const self = this;
      self.$refs.editObjForm.validate((valid) => {
        if (valid) {
          this.editObj.planAt =
            Util.formatDate(this.editObj._planAt1) +
            " " +
            this.editObj._planAt2 +
            ":00";
          self.editDoing = true;
          Schedule.update(self.row.id, self.editObj).then(function (res) {
            self.editDoing = false;
            self.editDF = false;
            if (res.status === 200) {
              self.$message({
                message: self.$t("prompt.editSuccess"),
                type: "success",
              });
              self.getTodaySchedule();
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
    // 取消
    cancel(row) {
      const self = this;
      self.cancelDoing = true;
      Schedule.cancel(row.id).then(function (res) {
        self.cancelDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.cancelSuccess"),
            type: "success",
          });
          self.getTodaySchedule();
        } else {
          self.sysError();
        }
      });
    },
    // 放弃
    giveUp(row) {
      const self = this;
      self.giveUpDoing = true;
      Schedule.giveUp(row.id).then(function (res) {
        self.giveUpDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.giveUpSuccess"),
            type: "success",
          });
          self.getTodaySchedule();
        } else {
          self.sysError();
        }
      });
    },
    // 完成
    finish(row) {
      const self = this;
      self.transDoing = true;
      Schedule.finish(row.id).then(function (res) {
        self.transDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.finishSuccess"),
            type: "success",
          });
          self.getTodaySchedule();
        } else {
          self.sysError();
        }
      });
    },
    showRecord(row) {
      this.currentRowId = row.id;
      this.showDF = true;
    },
    getSources() {
      const self = this;
      Source.findByTenantId().then(function (res) {
        if (res.status == 200) {
          self.sources = res.data;
        } else {
          self.sysError();
        }
      });
    },
    getScheduleTypes() {
      const self = this;
      ScheduleType.findByTenantId().then(function (res) {
        if (res.status === 200) {
          self.scheduleTypes = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //============
    getTodaySchedule() {
      const self = this;
      if (self.Permit.currentUser()._shopId == null) {
        return;
      }
      let obj = {
        currentPage: 1,
        days: 1,
        shopId: self.Permit.currentUser()._shopId,
      };
      Schedule.findScheduleByDate(obj).then(function (res) {
        if (res.status == 200) {
          self.schedule = res.data[0];
        } else {
          self.sysError();
        }
      });
    },
  },
};
</script>
<style scoped>
.content {
  border-top: 1px solid rgb(233, 231, 231);
  padding: 10px 0px;
}
.content-item {
  border-bottom: 1px dotted rgb(233, 231, 231);
}
.border {
  /* border: 1px solid #ebeef5; */
  border: 1px solid rgb(233, 231, 231);
}
</style>